    import { Component, HostListener, Inject } from '@angular/core';
    import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
    import { DOCUMENT } from '@angular/common';
    import { filter } from 'rxjs/operators';

    const MOBIRISE_SCRIPTS: string[] = [
  "assets/bootstrap/js/bootstrap.bundle.min.js",
  "assets/smoothscroll/smooth-scroll.js",
  "assets/ytplayer/index.js",
  "assets/dropdown/js/navbar-dropdown.js",
  "assets/mbr-switch-arrow/mbr-switch-arrow.js",
  "assets/theme/js/script.js"
];

    @Component({
      selector: 'app-root',
      standalone: true,
      imports: [RouterOutlet],
      template: '<router-outlet />',
    })
    export class AppComponent {
      constructor(
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
      ) {
        // After every navigation, help legacy scripts recalibrate (layout, scroll, etc.)
        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
          setTimeout(() => {
            try {
              window.dispatchEvent(new Event('resize'));
              window.dispatchEvent(new Event('scroll'));
            } catch {}

            // If you need hard re-init for specific scripts, uncomment the next line.
            // this.reinjectScripts();
          }, 0);
        });
      }

      @HostListener('document:click', ['$event'])
      onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement | null;
        if (!target) return;

        const a = target.closest('a') as HTMLAnchorElement | null;
        if (!a) return;

        const href = a.getAttribute('href') || '';
        if (!href) return;

        // Ignore external links, mailto, tel, anchors-only, javascript:
        if (href.startsWith('http') || href.startsWith('//') || href.startsWith('mailto:') ||
            href.startsWith('tel:') || href.startsWith('#') || href.startsWith('javascript:')) {
          return;
        }

        // Mobirise internal navigation often uses *.html (optionally with #fragment)
        const m = href.match(/^([^?#]+\.html)(#.*)?(\?.*)?$/i);
        if (!m) return;

        event.preventDefault();

        const file = m[1];
        const fragment = (m[2] || '').replace('#', '') || undefined;

        const name = file.replace(/\.html$/i, '');
        const route = name.toLowerCase() === 'index' ? '' : name;

        this.router.navigate([`/${route}`], { fragment });
      }

      private reinjectScripts() {
        // WARNING: reinjecting scripts can duplicate side effects.
        // Use only if some Mobirise interactions break after route change.
        const body = this.document.body;
        const now = Date.now();

        for (const src of MOBIRISE_SCRIPTS) {
          const s = this.document.createElement('script');
          s.src = src + (src.includes('?') ? '&' : '?') + 'ngReload=' + now;
          s.defer = true;
          body.appendChild(s);
        }
      }
    }
